import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as pbi from 'powerbi-client';
import * as pbiModels from 'powerbi-models';
import { StatisticsService } from 'src/app/services';
import { AuthService } from 'src/app/shared';

@Component({
    selector: 'app-statistics-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.css']
})
export class StatisticsIndexComponent implements OnInit {
    public statisticsUrl: SafeResourceUrl;
    public locationScreeningsStatisticsUrl: SafeResourceUrl;
    public riskCalculationsStatisticsUrl: SafeResourceUrl;

    public isDisplayLocationScreenings: boolean;
    public isDisplayScreeningsAssessments: boolean;
    public isDisplayRiskCalculations: boolean;

    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly statisticsService: StatisticsService,
        private readonly authService: AuthService) {
    }

    public ngOnInit(): void {
        this.statisticsService.getScreeningsAndRiskAssessments().subscribe(res => {
            this.statisticsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.embedUrl);
            this.showReport(res.token, res.embedUrl, res.id, 'screeningsAndAssessmentsReportContainer', 'Location');
            this.isDisplayScreeningsAssessments = true;
        });
        this.statisticsService.getLocationScreenings().subscribe(res => {
            this.locationScreeningsStatisticsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.embedUrl);
            this.showReport(res.token, res.embedUrl, res.id, 'locationScreeningsReportContainer', 'Location');
            this.isDisplayLocationScreenings = true;
        });

        this.statisticsService.getRiskCalculations().subscribe((res: any) => {
            this.riskCalculationsStatisticsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.embedUrl);
            this.showReport(res.token, res.embedUrl, res.id, 'riskCalculationsReportContainer', 'RiskCalculation');
            this.isDisplayRiskCalculations = true;
        });

    }
    private showReport(
        accessTokenValue: string, 
        embedUrlValue: string, 
        embedReportId: string, 
        htmlElement: string,
        tableName: string): void {
        const filterTarget: pbiModels.IFilterGeneralTarget  = {
            table: tableName,
            column: 'Region'
        };
        const regionCode = this.authService.getRegionCode();
        let basicFilter: pbi.models.BasicFilter;
        if (this.authService.isFullAccessUser()) {
            const fitlerOperator = 'All';
            basicFilter = new pbi.models.BasicFilter(filterTarget, fitlerOperator, []);
        } else {
            const fitlerOperator = 'In';
            basicFilter = new pbi.models.BasicFilter(filterTarget, fitlerOperator, [regionCode]);
            basicFilter.requireSingleSelection = true;
            basicFilter.displaySettings = {
                isLockedInViewMode: true
            };
        }

        const config = {
            type: 'report',
            tokenType: pbi.models.TokenType.Embed,
            accessToken: accessTokenValue,
            embedUrl: embedUrlValue,
            id: embedReportId,
            permissions: pbi.models.Permissions.Read,
            filters: [
                basicFilter.toJSON()
            ],
            settings: {
                filterPaneEnabled: true,
                navContentPaneEnabled: false,
                localeSettings: {}
            }
        };

        const reportContainer = document.getElementById(htmlElement) as HTMLElement;
        const powerbi = new pbi.service.Service(
            pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
        const report = powerbi.embed(reportContainer, config) as pbi.Report;
    }
}
